import React from 'react';
import styled from 'styled-components';

const FooterStyle = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0;
    z-index: 10;
    width: 100%;
    height: 30px;
    font-size: ${props => props.theme.smallFont};
    font-family: ${props => props.theme.sansSerif};
    background-color: ${props => props.theme.darkGrey};
`;

type ProfileProps = {
    profile: string
};

export const ProfileCopyrightFooter = ({ profile }: ProfileProps) => {
    const year = new Date().getFullYear();

    return (
        <FooterStyle>© {year} {profile}</FooterStyle>
    );
};

export default ProfileCopyrightFooter;
